<template>
  <div class="home_page">
    <!-- 导航栏 -->
    <nav class="top_nav">
      <div class="nav_left">
        <a
          v-for="(item, index) in navItems"
          :key="index"
          href="javascript:;"
          class="nav_item"
          :class="{ active: activeNav === index }"
          @click="handleNavClick(index)"
        >
          {{ item }}
        </a>
      </div>
    </nav>

    <!-- 主展示区：左侧大视频 + 右侧列表，只有首页显示 -->
    <div v-if="activeNav === 0" class="hero_section">
      <!-- 左侧大视频区 -->
      <div class="hero_main">
        <div class="banner_bg_blur" :style="{ backgroundImage: `url(getBannerVal(activeBanner,'image'))` }"></div>
        <div class="banner_img">
          <video
            v-if="getBannerVal(activeBanner,'anchor_video')"
            ref="mainVideo"
            class="banner-video"
            muted
            playsinline
            @ended="onVideoEnded"
          ></video>
        </div>
        <div class="banner_overlay"></div>
        <div class="banner_info">
          <span class="live_tag">直播中</span>
          <h2 class="banner_title">{{ getBannerVal(activeBanner,'content') }}</h2>
          <div class="anchor_info">
            <img :src="getBannerVal(activeBanner,'touxiang')" class="anchor_avatar" />
            <span class="anchor_name">{{ getBannerVal(activeBanner,'anchor_name') }}</span>
          </div>
          <div class="stats">
            <span class="stat_item"> <img src="../../assets/renshu.png" alt="">{{ getBannerVal(activeBanner,'anchor_number') }} 人正在观看</span>
            <span class="stat_item"> <img src="../../assets/xihuan.png" alt="">{{ getBannerVal(activeBanner,'hot') }} 人喜欢</span>
          </div>
        </div>
        <button class="enter_btn" @click="enterLiveRoom( getBannerVal(activeBanner,'id'), getBannerVal(activeBanner,'anchorid'))">点击进入直播</button>
      </div>
      <!-- 右侧列表 -->
      <div class="hero_sidebar">
        <div
          v-for="(item, index) in bannerList"
          :key="item.id"
          class="sidebar_item"
          :class="{ active: activeBannerIndex === index }"
          @click="switchBanner(index)"
        >
          <img :src="getBannerVal(item,'image')" class="sidebar_img" />
          <div class="sidebar_mask"></div>
          <div class="sidebar_live_badge">
            <span class="sidebar_live_text">直播测试</span>
            <span class="sidebar_live_count">
              <img src="../../assets/renshu.png" alt="">
              {{ getBannerVal(item,'anchor_number') || getBannerVal(item,'hot') || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 甜筒精选 -->
    <section class="section">
      <div class="section_header">
        <h3 class="section_title">{{ activeNav === 0 ? '推荐直播' : navItems[activeNav] }}</h3>
      </div>
      <div :class="hasTitleParam ? 'featured_grid' : 'featured_grid_horizontal'">
        <div v-for="item in featuredList" :key="item.id" :class="hasTitleParam ? 'featured_card' : 'featured_card_horizontal'" @click="handleCardClick(item)">
          <div :class="hasTitleParam ? 'card_image_wrap' : 'card_image_wrap_horizontal'">
            <img :class="hasTitleParam ? 'card_image' : 'card_image_horizontal'" :src="getBannerVal(item,'image')" alt="">
            <!-- 遮罩层：待开播时更深 -->
            <div :class="getBannerVal(item,'statuss') == 0 ? 'card_overlay_offline' : (hasTitleParam ? 'card_overlay' : 'card_overlay_horizontal')"></div>
            <!-- 待开播中间显示 -->
            <div v-if="getBannerVal(item,'statuss') == 0 " class="offline_center_text">
              <div class="offline_status">待开播</div>
              <div v-if="getBannerVal(item,'add_time')" class="offline_time">{{ getBannerVal(item,'add_time') }}</div>
            </div>
            <div :class="hasTitleParam ? 'live_badge' : 'live_badge_horizontal'">
              <!-- 只有在选择类型（hasTitleParam=true）时才判断huifang字段 -->
              <template v-if="hasTitleParam">
                <!-- huifang为0是直播，为1是回放 -->
                <!-- huifang=0直播：正常显示直播标签+人数 -->
                <template v-if="getBannerVal(item,'huifang') == 0">
                  <span class="live_badge_text">直播测试</span>
                  <span class="live_badge_count">
                    <img src="../../assets/renshu.png" alt="">
                    {{ getBannerVal(item,'anchor_number') }}
                  </span>
                </template>
                <!-- huifang=1回放：只显示回放二字，紫色背景，隐藏人数 -->
                <template v-else>
                  <span class="live_badge_text_live">回放</span>
                </template>
              </template>
              <!-- 首页（hasTitleParam=false）保持原有逻辑 -->
              <template v-else>
                <span :class="getBannerVal(item,'statuss') == 0 ? 'live_badge_text_offline' : 'live_badge_text'">{{ getBannerVal(item,'statuss') == 0 ? '待开播' : '直播测试' }}</span>
                <span v-if="getBannerVal(item,'statuss') == 1" class="live_badge_count">
                  <img src="../../assets/renshu.png" alt="">
                  {{ getBannerVal(item,'anchor_number') }}
                </span>
              </template>
            </div>
            <!-- 封面左下角显示content介绍 -->
            <div :class="hasTitleParam ? 'card_content' : 'card_content_horizontal'">
              {{ getBannerVal(item,'content') }}
            </div>
            <!-- 类型 -->
             <div class="leixing_tuijian">#{{ getBannerVal(item,'leixing') }}</div>
          </div>
          <div :class="hasTitleParam ? 'card_info' : 'card_info_horizontal'">
            <img :src="getBannerVal(item,'touxiang')" :class="hasTitleParam ? 'card_avatar' : 'card_avatar_horizontal'" />
            <span :class="hasTitleParam ? 'card_name' : 'card_name_horizontal'">{{ getBannerVal(item,'anchor_name') }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 甜筒活动：只有首页显示 -->
    <section v-if="activeNav === 0" class="section">
      <h3 class="section_title">甜筒活动</h3>
      <div class="activity_grid">
        <div v-for="item in activityList" @click="Tiaozhuan(item)" :key="item.id" class="activity_card">
          <img class="activity_image" :src="item.image" alt="">
        </div>
        <div class="weichengnianjubao">
          <a  class="f-2"  href="https://www.12377.cn/" target="__blank">
            <img style="width: 100%; height:100%;" src="../../assets/buliangjubao.jpeg" alt="">
          </a>
          
          <div class="f-2" @click="wcnTc" style="cursor: pointer;">
            <img style="width: 100%; height: 100%;" src="../../assets/baohukaiqi.jpeg" alt="">
          </div>
        </div>
      </div>
    </section>

    <!-- 直播回放：只有首页显示 -->
    <section v-if="activeNav === 0" class="section">
      <h3 class="section_title">直播回放</h3>
      <div class="category_grid">
        <div v-for="item in categoryList" :key="item.id" class="category_card" @click="huifang(getBannerVal(item,'id'),getBannerVal(item,'anchorid'))">
          <img class="category_image" :src="getBannerVal(item,'hfimage')" alt="">
          <div class="category_overlay"></div>
          <div class="category_live_badge">
            <span class="category_live_text">回放</span>
          </div>
          <div class="category_anchor">
            <img :src="getBannerVal(item,'touxiang')" class="category_avatar" />
            <span class="category_name">{{ getBannerVal(item,'anchor_name') }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import Hls from 'hls.js';
export default {
  name: 'HomePage',
  components:{},
  data() {
    return {
      navItems: ['首页','音乐', '乐器', '舞蹈', '颜值', '生活方式'],
      activeNav: 0, // 默认无选中
      activeBannerIndex: 0,
      hlsInstance: null,
      bannerList: [],
      currentVideoTime: 0,
      featuredList: [],
      categoryList: [],
      activityList: [
        { id: 1, image: require('../../assets/guizeti.png') },
        { id: 2, image: require('../../assets/jiyi.png') }
      ],
      // 是否有title参数，控制推荐直播布局
      hasTitleParam: false,


    }
  },
  computed: {
    activeBanner() {
      return this.bannerList[this.activeBannerIndex] || {}
    }
  },
  mounted() {
    this.AXIOS_getdata()
    // 监听页面刷新/关闭事件，在离开前保存进度
    // 使用箭头函数确保 this 指向组件实例
    this._beforeUnloadHandler = () => {
      this.handleBeforeUnload()
    }
    window.addEventListener('beforeunload', this._beforeUnloadHandler)
  },
  watch: {
    activeBannerIndex() {
      this.$nextTick(() => {
        this.playActiveVideo()
      })
    }
  },
  methods: {
    // 导航点击处理
    handleNavClick(index) {
      this.activeNav = index==0?0:index;
      // 点击后重新获取数据，传递选中的分类
      this.AXIOS_getdata();
    },
    // 通用取值：有anchor取子对象，没有取外层（适配three回放anchor=null）
    getBannerVal(item, key){
      if(!item) return ''
      if(item.anchor && item.anchor[key] !== undefined){
        return item.anchor[key]
      }else{
        return item[key] || ''
      }
    },
    goToLogin() {
      this.$router.push('/gr');
    },
    //广告位跳转
    Tiaozhuan(item){
      console.log(item.id);
       axios.post('https://ttxq.xiangyouhulian.cn/api/index/batwo')
       .then( res=>{
        // console.log(res.data.data[0].id,res.data.data[0].anchorid);
        if(item.id==3){
          window.open('https://www.12377.cn/','_blank');
        }else if(item.id==2){
          this.enterLiveRoom(res.data.data[0].id,res.data.data[0].anchorid);
        }else if(item.id==1){
          this.enterLiveRoom(res.data.data[1].id,res.data.data[1].anchorid);
        }
       }).catch(err=>{
        console.log(err)
       })
     
    },
    //未成年人跳转（未登录时-登录时跳转的不一样）
    wcnTc(){
      console.log('wcnTc clicked');
      // 检查用户是否登录
      const isLoggedIn = this.$store.state.LoginStorage && this.$store.state.LoginStorage.id
      console.log('isLoggedIn:', isLoggedIn)
      if (isLoggedIn) {
        // 已登录：跳转到设置页面并自动打开未成年人模式弹窗
        this.$router.push({
          path: '/shezhi',
          query: { openTeenagerModal: 'true' }
        })
      } else {
        // 未登录：通知父组件显示未成年人保护提示弹窗
        console.log('emitting showMinorProtection')
        this.$emit('showMinorProtection')
      }
    },
    //每秒都会执行
    // onVideoTimeUpdate() {
    //   const currentBanner = this.activeBanner;
    //   const anchorid = this.getBannerVal(currentBanner, 'anchorid')
    //   const video = this.$refs.mainVideo
    //   if (!video) return
    //   console.log('@@@@@@@-当前播放视频的id信息:', 'id：',currentBanner.id,'anchorid：',anchorid)
    // },
    // 视频播放完成回调
    onVideoEnded() {
      const currentBanner = this.activeBanner;
      if (!currentBanner?.id) return
      const anchorid = this.getBannerVal(currentBanner, 'anchorid')
      if (!anchorid) return
      // 视频播放完成，调用接口保存1800秒
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/saveAdd10Sec', {
        vid: currentBanner.id,
        pos: anchorid,
        sec: 1800
      }).then(res => {
        console.log('视频播放完成，保存进度成功:', res.data)
      }).catch(err => {
        console.log('视频播放完成，保存进度失败:', err)
      })
    },
    // 处理页面刷新或关闭前的保存逻辑
    handleBeforeUnload() {
      // 页面关闭前使用 sendBeacon 同步保存进度到后端
      const video = this.$refs.mainVideo
      const currentBanner = this.activeBanner
      if (!video || !currentBanner?.id) return
      const anchorid = this.getBannerVal(currentBanner, 'anchorid')
      if (!anchorid) return
      const currentTime = Math.floor(video.currentTime || 0)
      if (currentTime <= 0) return
      
      const data = JSON.stringify({
        vid: currentBanner.id,
        pos: anchorid,
        sec: currentTime
      })
      
      // 使用 sendBeacon 确保请求在页面关闭前发送
      const url = 'https://ttxq.xiangyouhulian.cn/api/index/saveAdd10Sec'
      const blob = new Blob([data], { type: 'application/json' })
      navigator.sendBeacon(url, blob)
    },
    enterLiveRoom(id, pos) {
      console.log('进入直播间，id:', id, 'pos:', pos)
      this.saveCurrentVideoProgress()
      this.$router.push(`/zb/${id}/${pos || 1}`);
    },
    // 处理卡片点击 - 根据huifang字段判断跳转
    handleCardClick(item) {
      const id = this.getBannerVal(item, 'id')
      const anchorid = this.getBannerVal(item, 'anchorid')
      const huifang = this.getBannerVal(item, 'huifang')
      
      // 只有在选择类型页面（hasTitleParam=true）且huifang=1时才跳转到回放页
      if (this.hasTitleParam && huifang == 1) {
        console.log('跳转到回放页面，id:', id, 'anchorid:', anchorid)
        // TODO: 这里先用假路径，后面自己改成真实路径
        this.$router.push(`/hf/${id}/${anchorid}`);
      } else {
        // 其他情况进入直播间
        this.enterLiveRoom(id, anchorid);
      }
    },
    //huifang
    huifang(id,pos) {
      // this.saveCurrentVideoProgress()
      this.$router.push(`/hf/${id}/${pos}`);
    },
    switchBanner(index) {
      // 切换视频前：先保存当前视频的观看进度
      this.saveCurrentVideoProgress()
      // 更新当前视频ID（用于localStorage的key）
      const newBanner = this.bannerList[index] || {}
      this.currentVideoId = this.getBannerVal(newBanner, 'id')
      // 切换active索引，触发watch中的playActiveVideo
      this.activeBannerIndex = index
    },
    saveCurrentVideoProgress() {
      const video = this.$refs.mainVideo
      const currentBanner = this.activeBanner
      if (!video || !currentBanner?.id) return
      const anchorid = this.getBannerVal(currentBanner,'anchorid')
      if(!anchorid) return
      const currentTime = Math.floor(video.currentTime || 0)
      if (currentTime <= 0) return
      // const sendSec = currentTime >= 1800 ? 0 : currentTime
      console.log(currentTime, '秒，保存视频进度')
      // vid传递主播记录的id，pos传递anchorid
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/saveAdd10Sec', {
        vid: currentBanner.id,
        pos: anchorid,
        sec: currentTime
      }).then(res => {
        console.log('保存视频进度成功:', res.data)
        // 保存成功后不刷新数据，避免页面闪烁
      }).catch(err => {
        console.log('保存视频进度失败:', err)
      })
    },
    getVideoProgress(vid, pos) {
      return new Promise((resolve) => {
        axios.get('https://ttxq.xiangyouhulian.cn/api/index/getinfo', {
          params: { vid, pos }
        }).then(res => {
          console.log('获取视频进度:', res.data)
          if (res.data.data) {
            resolve(parseFloat(res.data.data.start_second) || 0)
          } else {
            resolve(0)
          }
        }).catch(err => {
          console.log('获取视频进度失败:', err)
          resolve(0)
        })
      })
    },
    destroyHls() {
      if (this.hlsInstance) {
        this.hlsInstance.destroy()
        this.hlsInstance = null
      }
    },
    initHls(video, videoUrl, startTime = 0) {
      this.destroyHls()
      video.src = ''
      // 保存startTime到data，供后续使用
      this.pendingStartTime = startTime
      if (Hls.isSupported()) {
        const hls = new Hls({
          debug: false,
          enableWorker: true,
          lowLatencyMode: true,
          backBufferLength: 90
        })
        this.hlsInstance = hls
        hls.loadSource(videoUrl)
        hls.attachMedia(video)
        
        // 关键：在MANIFEST_PARSED时先暂停，设置currentTime后再播放
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          // 如果有起始时间，检查seekable范围
          if (this.pendingStartTime > 0) {
            const seekableEnd = video.seekable.length > 0 ? video.seekable.end(0) : 0
            const seekableStart = video.seekable.length > 0 ? video.seekable.start(0) : 0
            
            // 如果seekable已经有数据
            if (seekableEnd > 0) {
              if (this.pendingStartTime >= seekableStart && this.pendingStartTime <= seekableEnd) {
                // 目标时间在范围内，正常seek
                video.currentTime = this.pendingStartTime
              } else {
                // 目标时间超出范围，从0开始
                video.currentTime = 0
              }
              this.pendingStartTime = 0
            }
            // 否则等canplay事件再处理
          }
          
          video.play().catch(() => {})
        })
        
        // 关键：在视频可以播放时再检查一次（MANIFEST_PARSED时seekable可能还没准备好）
        const seekHandler = () => {
          const targetTime = this.pendingStartTime
          if (targetTime > 0 && video.seekable.length > 0) {
            const seekableEnd = video.seekable.end(0)
            const seekableStart = video.seekable.start(0)
            
            if (targetTime >= seekableStart && targetTime <= seekableEnd) {
              // 目标时间在范围内，正常seek
              video.currentTime = targetTime
            } else {
              // 目标时间超出范围，从0开始
              video.currentTime = 0
            }
            this.pendingStartTime = 0
          }
          video.removeEventListener('canplay', seekHandler)
          video.removeEventListener('loadedmetadata', seekHandler)
        }
        video.addEventListener('canplay', seekHandler)
        video.addEventListener('loadedmetadata', seekHandler)
        hls.on(Hls.Events.ERROR, (event, data) => {
          console.error('HLS 错误:', event, data)
          if (data.fatal) {
            switch (data.type) {
              case Hls.ErrorTypes.NETWORK_ERROR:
                console.log('网络错误，尝试恢复...')
                hls.startLoad()
                break
              case Hls.ErrorTypes.MEDIA_ERROR:
                console.log('媒体错误，尝试恢复...')
                hls.recoverMediaError()
                break
              default:
                console.log('无法恢复的错误，销毁实例')
                hls.destroy()
                this.hlsInstance = null
                break
            }
          }
        })

      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        console.log('使用原生 HLS 播放')
        video.src = videoUrl
        video.addEventListener('loadedmetadata', () => {
          if (this.pendingStartTime > 0) {
            video.currentTime = this.pendingStartTime
            this.pendingStartTime = 0
          }
          video.play().catch((err) => {
            console.log('自动播放被阻止:', err)
          })
        })
      } else {
        console.error('浏览器不支持 HLS 播放')
      }
    },
    async playActiveVideo() {
      const video = this.$refs.mainVideo
      if (!video) return
      const videoUrl = this.getBannerVal(this.activeBanner,'anchor_video')
      if (!videoUrl) {
        console.log('当前没有视频')
        return
      }
      // anchorid作为pos参数，id作为vid参数
      const anchorid = this.getBannerVal(this.activeBanner,'anchorid')
      // 获取当前视频的唯一标识，用于localStorage的key
      const videoId = this.getBannerVal(this.activeBanner, 'id')
      
      console.log('videoId', videoId, 'anchorid', anchorid, 'videoUrl', videoUrl)
      this.currentVideoId = videoId
      // 从后端API获取进度
      let startTime = await this.getVideoProgress(videoId, anchorid)
      console.log('最终从', startTime, '秒开始播放')
      this.initHls(video, videoUrl, startTime)
    },
    AXIOS_getdata(){
      // 获取title参数：优先使用选中的导航，否则使用URL参数
      let titleParam = '';
      if (this.activeNav >= 0) {
        // 有选中的导航，使用导航值
        titleParam = this.activeNav==0?'': this.navItems[this.activeNav];
      } else {
        // 无选中导航，使用URL参数
        titleParam = this.$route.query.title || '';
      }
      this.hasTitleParam = !!titleParam;

      axios.get('https://ttxq.xiangyouhulian.cn/api/index/getData',{params:{title:titleParam}})
        .then(response => {
          console.log('获取数据成功:', response.data.data);
          this.bannerList = response.data.data.one || [];
          this.featuredList = response.data.data.two || [];
          this.categoryList = response.data.data.three || [];
          this.$nextTick(() => {
            setTimeout(() => {
              this.playActiveVideo()
            }, 300)
          })
        })
        .catch(error => {
          console.error('获取轮播图数据失败:', error)
        })
    },

  },
  beforeDestroy() {
    // 组件销毁前：移除事件监听、保存进度、销毁HLS实例
    // 移除页面刷新/关闭的事件监听，防止内存泄漏
    if (this._beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this._beforeUnloadHandler)
    }
    // 最后一次保存视频进度到后端
    this.saveCurrentVideoProgress()
    // 销毁HLS播放器实例，释放资源
    this.destroyHls()
  }
}
</script>

<style scoped lang="scss">
.home_page {
 padding: 0px 70px;
  background-color: #ffffff;
  min-height: 100vh;
}
.top_nav {
  display: flex;
  align-items: center;
  padding: 16px 0px;
  margin-bottom: 16px;
  border-radius: 12px;
}
.nav_left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nav_item {
  font-size: 14px;
  color: #666;
  text-decoration: none;
  position: relative;
  padding: 10px 20px;
  border-radius: 20px;
  transition: all 0.3s ease;
  white-space: nowrap;
  background-color: #49367914;
  &:hover {
    color: #8B5CF6;
    background: rgba(139, 92, 246, 0.08);
  }
  &.active {
    color: #fff;
    font-weight: 500;
    background: linear-gradient(135deg, #8B5CF6 0%, #A855F7 100%);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.3);
  }
}
.hero_section {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  border-radius: 16px;
  overflow: hidden;
  // 高度由主视频区决定
  height: auto;
}
.hero_main {
  position: relative;
  flex: 1;
  border-radius: 16px;
  overflow: hidden;
  // 主视频区保持16:9比例
  aspect-ratio: 16 / 9;
}
.banner_bg_blur {
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  background-size: cover;
  background-position: center;
  filter: blur(20px);
  z-index: 0;
}
.banner_img {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  video {
    // 视频填满容器，保持比例裁剪
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.banner_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.2) 50%, transparent 100%);
  z-index: 3;
}
.banner_info {
  position: absolute;
  left: 32px;
  bottom: 32px;
  color: #fff;
  z-index: 3;
}
.live_tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  background: #FF1493;
  border-radius: 20px;
  font-size: 12px;
  margin-bottom: 12px;
  color: #fff;
  font-weight: 500;
  &::before {
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #fff;
    border-radius: 50%;
  }
}
.banner_title {
  width: 500px;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}
.anchor_info {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.anchor_avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 8px;
  border: 2px solid #fff;
}
.anchor_name {
  font-size: 14px;
}
.stats {
  display: flex;
  gap: 16px;
}
.stat_item {
  font-size: 13px;
  font-weight: 400;
  color: #dbdbdb;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stat_item img {
  width: 13px;
  height: 13px;
  margin-right: 5px;
}
.enter_btn {
  position: absolute;
  right: 42%;
  bottom: 32px;
  padding: 12px 32px;
  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 24px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  z-index: 3;
  transition: all 0.3s ease;
  &:hover {
    background: rgba(255,255,255,0.3);
  }
}
.hero_sidebar {
  // 侧边栏宽度按整体比例（约20%），最小200px
  width: 20%;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
}
.sidebar_item {
  position: relative;
  // 高度自适应填充，保持16:9比例
  flex: 1;
  aspect-ratio: 16 / 9;
  min-height: 100px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  &:hover {
    border-color: rgba(255,255,255,0.5);
  }
  &.active {
    border-color: #FFD700;
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
  }
}
.sidebar_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sidebar_mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 50%);
}
.sidebar_live_badge {
  position: absolute;
  bottom: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
  font-size: 12px;
  color: #fff;
}
.sidebar_live_text {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  background: #FF1493;
  font-weight: 500;
}
.sidebar_live_count {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  color: #d2d2d2;
  img{
    width: 13px;
    height: 13px;
    margin-top: 2px;
  }
  .user_icon {
    width: 12px;
    height: 12px;
    opacity: 0.9;
  }
}
.section {
  margin-bottom: 32px;
}
.section_header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
}
.section_title {
  font-size: 20px;
  font-weight: 600;
  color: #181426;
  margin-bottom:20px;
}
.featured_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
.featured_card {
  cursor: pointer;
}
.card_image_wrap {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
  aspect-ratio: 3 / 4;
}
.card_image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.card_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 50%);
  border-radius: 12px;
}
// 待开播遮罩层 - 更深的颜色
.card_overlay_offline {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.2) 100%);
  border-radius: 12px;
}
// 待开播中间文字
.offline_center_text {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  z-index: 2;
  
  .offline_status {
    font-size: 18px;
    font-weight: 600;
    color: #fff;
    padding: 8px 20px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 20px;
  }
  
  .offline_time {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    margin-top: 8px;
    padding: 4px 12px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 12px;
  }
}
.live_badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
  font-size: 12px;
  color: #fff;
}
.live_badge_text {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #FF1493;
  font-weight: 500;
}
// 直播标签 - 紫色（huifang=0时只显示回放二字）
.live_badge_text_live {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #8B5CF6;
  font-weight: 500;
  border-radius: 20px;
}
// 待开播标签 - 黄色
.live_badge_text_offline {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #FFB800;
  font-weight: 500;
}
.live_badge_count {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 4px 5px;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  color: #dbdbdb;
  img{
    width: 13px;
    height: 13px;
    margin-top: 2px;
    margin-right: 2px;
  }
}
.user_icon {
  width: 14px;
  height: 14px;
  opacity: 0.9;
}
.card_info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.card_avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.card_name {
  font-size: 14px;
  color: #4B3B73;
}

// 封面内容介绍（左下角）
.card_content {
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  font-size: 14px;
  color: #fff;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  z-index: 2;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
  width: 80%;
  /* 溢出隐藏 */
            overflow: hidden;
            /* 不让文本换行 除非遇到br标签 */
            white-space:nowrap;
            /* 溢出文字用...代替 */
            text-overflow: ellipsis;
}

// 横向布局时的内容介绍
.card_content_horizontal {
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  font-size: 14px;
  color: #fff;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  z-index: 2;
  text-shadow: 0 1px 3px rgba(0,0,0,0.6);
  width: 80%;
  /* 溢出隐藏 */
            overflow: hidden;
            /* 不让文本换行 除非遇到br标签 */
            white-space:nowrap;
            /* 溢出文字用...代替 */
            text-overflow: ellipsis;
}
//类型
.leixing_tuijian{
  font-size: 20px;
  position: absolute;
  bottom: 35px;
  left: 8px;
  right: 8px;
  color: #ff2b87;
  font-weight: 700;
}

.category_grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
}
.category_card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 200px;
}
.category_image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.category_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 60%);
}
.category_live_badge {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
  font-size: 12px;
  color: #fff;
}

.category_live_text {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  background: #8B5CF6;
  font-weight: 500;
  border-radius: 20px;
}

.category_tag {
  position: absolute;
  bottom: 40px;
  left: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}
.category_anchor {
  position: absolute;
  bottom: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.category_avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.category_name {
  font-size: 15px;
  color: #fff;
}
.activity_grid { 
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  // 大于1930px大屏
  @media (min-width: 1930px) {
    height: 340px;
  }
  // 小于1930px小屏
  @media (max-width: 1929px) {
    height: 270px;
  }
}

.activity_card {
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  object-fit: cover;
}
.activity_image {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.weichengnianjubao{
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  gap: 16px;
}
.weichengnianjubao .f-2{
  width: 100%;
  height: 100%;
 // max-height: 125px;
  object-fit: cover;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  display: block;
  
}
.f-2 img{
  // 屏幕宽度小于1920px时
  @media (min-width: 1920px) {
    height: 133% !important;
  }
}

// 横向布局 - 无title参数时使用
.featured_grid_horizontal {
  display: grid;
  // 固定5列布局
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}
.featured_card_horizontal {
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
.card_image_wrap_horizontal {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 12px;
  // 16:9比例
  aspect-ratio: 16 / 9;
}
.card_image_horizontal {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}
.card_overlay_horizontal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to top, rgba(0,0,0,0.4) 0%, transparent 50%);
  border-radius: 12px;
}
.live_badge_horizontal {
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
  font-size: 12px;
  color: #fff;
}
.card_info_horizontal {
  display: flex;
  align-items: center;
  gap: 8px;
}
.card_avatar_horizontal {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}
.card_name_horizontal {
  font-size: 15px;
  color: #4B3B73;
}
</style>